import multiguard from 'vue-router-multiguard';

import ProtocolList from '@/modules/protocols/components/ProtocolList';
import Protocol from '@/modules/protocols/components/Protocol';
import ProtocolDashboardLayout
  from '@/modules/protocols/components/ProtocolDashboardLayout';

import BidsList from '@/modules/bids/components/BidsList';
import isAuthorized from '../../../router/hooks/isAuthorized';
import isMensurationForbidden from '../../../router/hooks/isMensurationForbidden';

export default [
  {
    path: '/protocols',
    component: ProtocolDashboardLayout,
    children: [
      {
        path: 'index',
        name: 'protocols',
        component: ProtocolList,
        beforeEnter: isAuthorized,
      },
      {
        path: 'bids',
        name: 'bids',
        component: BidsList,
        beforeEnter: isAuthorized,
      },
      {
        path: 'applications',
        name: 'applications',
        beforeEnter: isAuthorized,
      },
      {
        path: '/protocols/:protocolId/edit',
        name: 'protocol-edit',
        component: Protocol,
        props: true,
        beforeEnter: multiguard([isAuthorized, isMensurationForbidden]),
      },
      {
        path: '/protocols/create',
        name: 'protocol-create',
        component: Protocol,
        beforeEnter: multiguard([isAuthorized, isMensurationForbidden]),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/modules/protocols/routes/index.js